import React , { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import ContentNewsStyle from './contentNews.module.css';
import './contentNews.css'
import {Carousel} from 'antd';
import {connect} from 'react-redux';
import {fetch_homeNews} from '../../actions/home/homeNewsAction';
import {fetch_homeTechFinance} from '../../actions/home/homeTechFinanceAction';
import {fetch_carousel} from '../../actions/home/createCarouselAction';
import {withRouter} from "react-router";
import globalStyle from "../../styles/globalStyle";
import ellipsis from "../../styles/ellipsis.module.css";
import ellipsisContent from "../../utils/EllipsisContent";
import PaginationList from "../../common/Paginator/PaginationList";
import {getCarouselNews} from "./service";
import newsDetailPushTarget from "../../utils/NewsDetailPushTarget";

class ContentNews extends Component{

    state = {
        selectTabIndex: 0,
        carouselNewsData: [],
    };

    constructor(props){
        super(props);
        this.onChangeTab=this.onChangeTab.bind(this);
    }

    onChangeTab=(index)=>{
        this.setState({
            selectTabIndex:index,
        })
    }

    async componentDidMount() {

        const {data} = await getCarouselNews();
        this.setState({carouselNewsData: data})
    }

    render(){

        let tabSelectedSty={
            fontSize:'18px',
            fontFamily:'Microsoft YaHei',
            fontWeight:'bold',
            color:'rgba(51,51,51,1)',
            lineHeight:'18px',
        };

        return(
            <div className={ContentNewsStyle.contentNewsDiv}>
               <div className={ContentNewsStyle.inlineDiv}>
                    <div className={ContentNewsStyle.carouselDiv}>
                        <Carousel autoplay fade={true} >
                            {
                                this.state.carouselNewsData.map((item, index) => {
                                    const {id, title, cover_link} = item;
                                    if(index < 4) {
                                        return(
                                            <div className={ContentNewsStyle.carouselItem} key={index} onClick={() => {
                                                this.props.history.push({ pathname: `/${newsDetailPushTarget(item.tab)}/${id}`});
                                            }}>
                                                <div className={ContentNewsStyle.carouselItemImg} style={{backgroundImage:`url(${cover_link})`}}/>
                                                <div className={ContentNewsStyle.carouselItemTitle}>{title}</div>
                                            </div>
                                        );
                                    }
                                })
                            }
                        </Carousel>
                    </div>
                    <div className={ContentNewsStyle.newsDiv}>
                        <div className={ContentNewsStyle.newsMenuDiv}>
                            <div className={ContentNewsStyle.newsIcon}/>
                            <ul>
                               <li><a onClick={()=>{this.onChangeTab(0)}} style={this.state.selectTabIndex === 0 ? tabSelectedSty : null}>新闻焦点</a></li>
                               <li><a onClick={()=>{this.onChangeTab(1)}} style={this.state.selectTabIndex === 1 ? tabSelectedSty : null}>财税联盟</a></li>
                            </ul>
                            <div className={ContentNewsStyle.moreDiv} onClick={() => {
                                this.props.history.push({ pathname: this.state.selectTabIndex === 0 ? `/news`: `/techFinance`});
                            }}>更多&gt;&gt;</div>
                        </div>
                        <div className={ContentNewsStyle.splitLineSty}/>

                        <div className={ContentNewsStyle.tabConDivSty}>
                            <ul className={ContentNewsStyle.newsListSty}>
                                <PaginationList
                                    title={null}
                                    hidePagination
                                    url={this.state.selectTabIndex === 0 ? '/api/News' : '/api/Alliance'}
                                    requestOption={{params: {size: 5}}}
                                    renderListHeader={(data, rawData)=>{
                                        return(
                                            data.length > 0
                                                ?   <div style={{width: 586}}>
                                                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '16px 0'}}>
                                                            <div style={{...globalStyle.flexSpaceBetweenRow, marginBottom: 8}}>
                                                                <span style={{fontSize: 16, fontWeight: 700, color: '#333333', cursor: 'pointer',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace:'nowrap'}} onClick={() => {
                                                                    this.props.history.push({ pathname: `/${this.state.selectTabIndex === 0 ? 'news' : 'techFinance'}/detail/${rawData[0].id}`});
                                                                }}>{rawData[0].title}</span>
                                                            </div>
                                                            <span className={ellipsis.ellipsis3Line} style={{lineHeight: '25px', minHeight: 75}}>
                                                                {ellipsisContent(rawData[0].content, 100)}
                                                            </span>
                                                        </div>
                                                        <div className={ContentNewsStyle.splitLineSty}/>
                                                    </div>
                                                :   null
                                        );
                                    }}
                                    renderItem={(item) => {
                                        const {id, title, change_time} = item;
                                        return(
                                            <li key={id} onClick={() => {
                                                this.props.history.push({ pathname: `/${this.state.selectTabIndex === 0 ? 'news' : 'techFinance'}/detail/${id}`});
                                            }}>
                                                <div className={ContentNewsStyle.itemPointSty}/>
                                                <div className={ContentNewsStyle.itemTitleSty}>{title}</div>
                                                <div className={ContentNewsStyle.itemDateSty}>{moment(change_time).format('YYYY-MM-DD')}</div>
                                            </li>
                                        );
                                    }}
                                    onGetDataFinish={(data) => {
                                        data.list = data.list.slice(1, 5);
    
                                        //将日期按照从新到旧排序。
                                        data.list.sort((itemA,itemB)=>{
                                            return Date.parse(itemB.change_time)-Date.parse(itemA.change_time);
                                        })
                                        
                                        return data;
                                    }}
                                />
                            </ul>
                        </div>
                    </div>
               </div>
            </div>

        );

    }
}

export default connect()(withRouter(ContentNews));
